import { useState, useEffect } from "react";
import {
  User, Wallet, Calendar,
  ChevronRight, ChevronDown, ChevronUp,
  FileText, X, Check, XCircle,
} from "lucide-react";
import { fetchPersonalData, fetchDokumenData } from "../../../controller/mobile/home";

// ─── DATA ────────────────────────────────────────────────────────────────────

const employeeData = {
  nama: "Ahmad Rizki Pratama",
  nik: "1234567890123456",
  jabatan: "Software Engineer",
  departemen: "IT Development",
  email: "ahmad.rizki@company.com",
  telepon: "081234567890",
  alamat: "Jl. Merdeka No. 123, Jakarta Pusat",
  tanggalMasuk: "15 Januari 2022",
  photo: "https://api.dicebear.com/7.x/avataaars/svg?seed=Ahmad",
};

const salaryHistory = [
  { id: 1, bulan: "Desember 2024", gajiPokok: 8000000, tunjangan: 2000000, bonus: 1500000, potongan: 500000, total: 11000000 },
  { id: 2, bulan: "November 2024", gajiPokok: 8000000, tunjangan: 2000000, bonus: 0,       potongan: 500000, total: 9500000  },
  { id: 3, bulan: "Oktober 2024",  gajiPokok: 8000000, tunjangan: 2000000, bonus: 500000,  potongan: 500000, total: 10000000 },
];

const attendanceData = [
  {
    bulan: "Desember 2024", monthKey: "2024-12", totalKehadiran: 18, totalHari: 20,
    data: [
      { tanggal: "01", hari: "Senin",  status: "Hadir", sesi1: { hadir: true,  jamMasuk: "08:00", jamKeluar: "12:00" }, sesi2: { hadir: true,  jamMasuk: "13:00", jamKeluar: "17:00" } },
      { tanggal: "02", hari: "Selasa", status: "Hadir", sesi1: { hadir: true,  jamMasuk: "08:15", jamKeluar: "12:10" }, sesi2: { hadir: true,  jamMasuk: "13:05", jamKeluar: "17:10" } },
      { tanggal: "03", hari: "Rabu",   status: "Hadir", sesi1: { hadir: true,  jamMasuk: "07:55", jamKeluar: "12:00" }, sesi2: { hadir: false, jamMasuk: "-",     jamKeluar: "-"     } },
      { tanggal: "04", hari: "Kamis",  status: "Izin",  sesi1: { hadir: false, jamMasuk: "-",     jamKeluar: "-"     }, sesi2: { hadir: false, jamMasuk: "-",     jamKeluar: "-"     } },
      { tanggal: "05", hari: "Jumat",  status: "Hadir", sesi1: { hadir: true,  jamMasuk: "08:05", jamKeluar: "12:00" }, sesi2: { hadir: true,  jamMasuk: "13:00", jamKeluar: "17:00" } },
      { tanggal: "06", hari: "Sabtu",  status: "Libur", sesi1: { hadir: false, jamMasuk: "-",     jamKeluar: "-"     }, sesi2: { hadir: false, jamMasuk: "-",     jamKeluar: "-"     } },
      { tanggal: "07", hari: "Minggu", status: "Libur", sesi1: { hadir: false, jamMasuk: "-",     jamKeluar: "-"     }, sesi2: { hadir: false, jamMasuk: "-",     jamKeluar: "-"     } },
    ],
  },
  {
    bulan: "November 2024", monthKey: "2024-11", totalKehadiran: 16, totalHari: 22,
    data: [
      { tanggal: "01", hari: "Jumat", status: "Hadir", sesi1: { hadir: true,  jamMasuk: "08:00", jamKeluar: "12:00" }, sesi2: { hadir: true,  jamMasuk: "13:00", jamKeluar: "17:00" } },
      { tanggal: "02", hari: "Sabtu", status: "Libur", sesi1: { hadir: false, jamMasuk: "-",     jamKeluar: "-"     }, sesi2: { hadir: false, jamMasuk: "-",     jamKeluar: "-"     } },
    ],
  },
];

// ─── HELPERS ─────────────────────────────────────────────────────────────────

const formatCurrency = (amount : number) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(amount);

const getStatusColor = (status : string) =>
  ({ Hadir: "#10B981", Izin: "#F59E0B", Libur: "#6B7280" }[status] ?? "#EF4444");

// ─── TABBAR ──────────────────────────────────────────────────────────────────

function TabBar({ activeTab, setActiveTab } : { activeTab: string; setActiveTab: (tab: string) => void }) {
  const tabs = [
    { key: "profile",    label: "Profile",    Icon: User     },
    { key: "salary",     label: "Salary",     Icon: Wallet   },
    { key: "attendance", label: "Attendance", Icon: Calendar },
  ];
  return (
    <div style={{ display: "flex", backgroundColor: "white", justifyContent: "space-around", padding: "8px 12px", borderTop: "1px solid #E5E7EB" }}>
      {tabs.map(({ key, label, Icon }) => {
        const focused = activeTab === key;
        return (
          <button key={key} onClick={() => setActiveTab(key)}
            style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "0 8px", background: "none", border: "none", cursor: "pointer", gap: 4 }}>
            <Icon size={20} color={focused ? "#3B82F6" : "#64748B"} />
            <span style={{ fontSize: 12, color: focused ? "#3B82F6" : "#64748B", fontWeight: focused ? 600 : 400 }}>{label}</span>
          </button>
        );
      })}
    </div>
  );
}

// ─── PROFILE TAB ─────────────────────────────────────────────────────────────

function ProfileTab(data : any = "") {
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState<string | null>(null);
  const [docs, setDocs] = useState<any[]>([]);

  const init = async () => {
    try {
      data = await fetchDokumenData(data.id);
      console.log("Dokumen Data:", data);

    } catch (err) {
      console.error("Error fetching personal data:", err);
      setDocs([]);
    }
  };

  useEffect(() => {
    init();
  }, []);

  const infoRows = [
    ["NIK",           employeeData.nik],
    ["Email",         employeeData.email],
    ["Telepon",       employeeData.telepon],
    ["Alamat",        employeeData.alamat],
    ["Tanggal Masuk", employeeData.tanggalMasuk],
  ];

  return (
    <div style={{ flex: 1, overflowY: "auto", padding: 16 }}>
      {/* Profile Header */}
      <div style={{ display: "flex", gap: 16, backgroundColor: "white", padding: 16, borderRadius: 12, marginBottom: 16, alignItems: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
        <img src={employeeData.photo} alt="avatar" style={{ width: 80, height: 80, borderRadius: 40, backgroundColor: "#E5E7EB" }} />
        <div>
          <p style={{ margin: "0 0 4px", fontSize: 18, fontWeight: "bold", color: "#111827" }}>{employeeData.nama}</p>
          <p style={{ margin: "0 0 2px", fontSize: 14, color: "#6B7280" }}>{employeeData.jabatan}</p>
          <p style={{ margin: 0, fontSize: 14, color: "#6B7280" }}>{employeeData.departemen}</p>
        </div>
      </div>

      {/* Informasi Pribadi */}
      <div style={{ backgroundColor: "white", padding: 16, borderRadius: 12, marginBottom: 16, boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
        <p style={{ margin: "0 0 16px", fontSize: 16, fontWeight: 600, color: "#111827" }}>Informasi Pribadi</p>
        {infoRows.map(([label, value], i) => (
          <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "12px 0", borderBottom: i < infoRows.length - 1 ? "1px solid #F3F4F6" : "none" }}>
            <span style={{ fontSize: 14, color: "#6B7280", flex: 1 }}>{label}</span>
            <span style={{ fontSize: 14, color: "#111827", flex: 2, textAlign: "right" }}>{value}</span>
          </div>
        ))}
      </div>

      {/* Dokumen */}
      <div style={{ backgroundColor: "white", padding: 16, borderRadius: 12, boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
        <p style={{ margin: "0 0 16px", fontSize: 16, fontWeight: 600, color: "#111827" }}>Dokumen</p>
        {docs.map(([key, label]) => (
          <button key={key} onClick={() => { setSelectedDoc(key); setModalVisible(true); }}
            style={{ display: "flex", width: "100%", alignItems: "center", padding: 12, backgroundColor: "#F9FAFB", borderRadius: 8, marginBottom: 8, gap: 12, border: "none", cursor: "pointer", textAlign: "left" }}>
            <FileText size={20} color="#3B82F6" />
            <span style={{ flex: 1, fontSize: 14, color: "#111827" }}>{label}</span>
            <ChevronRight size={20} color="#9CA3AF" />
          </button>
        ))}
      </div>

      {/* Modal Dokumen */}
      {modalVisible && (
        <div onClick={() => setModalVisible(false)}
          style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16, zIndex: 1000 }}>
          <div onClick={e => e.stopPropagation()}
            style={{ backgroundColor: "white", borderRadius: 12, padding: 16, width: "100%", maxWidth: 400 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, paddingBottom: 12, borderBottom: "1px solid #E5E7EB" }}>
              <span style={{ fontSize: 18, fontWeight: "bold", color: "#111827" }}>
                {selectedDoc === "KK" ? "Kartu Keluarga" : "Kartu BPJS Kesehatan"}
              </span>
              <button onClick={() => setModalVisible(false)} style={{ background: "none", border: "none", cursor: "pointer", display: "flex" }}>
                <X size={24} color="#6B7280" />
              </button>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "40px 0" }}>
              <FileText size={100} color="#D1D5DB" strokeWidth={1} />
              <p style={{ marginTop: 16, fontSize: 14, color: "#6B7280" }}>Preview Dokumen</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── SALARY TAB ──────────────────────────────────────────────────────────────

function SalaryTab() {
  const [selectedSlip, setSelectedSlip] = useState<any | null>(null);

  return (
    <div style={{ flex: 1, overflowY: "auto", padding: 16 }}>
      <p style={{ margin: "0 0 16px", fontSize: 18, fontWeight: "bold", color: "#111827" }}>Riwayat Slip Gaji</p>

      {salaryHistory.map((item : any) => (
        <button key={item.id} onClick={() => setSelectedSlip(item)}
          style={{ display: "block", width: "100%", textAlign: "left", backgroundColor: "white", padding: 16, borderRadius: 12, marginBottom: 12, boxShadow: "0 1px 3px rgba(0,0,0,0.06)", border: "none", cursor: "pointer" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
            <span style={{ fontSize: 16, fontWeight: 600, color: "#111827" }}>{item.bulan}</span>
            <span style={{ fontSize: 18, fontWeight: "bold", color: "#10B981" }}>{formatCurrency(item.total)}</span>
          </div>
          <span style={{ fontSize: 13, color: "#3B82F6" }}>Lihat detail slip gaji →</span>
        </button>
      ))}

      {/* Modal Slip Gaji */}
      {selectedSlip && (
        <div onClick={() => setSelectedSlip(null)}
          style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16, zIndex: 1000 }}>
          <div onClick={e => e.stopPropagation()}
            style={{ backgroundColor: "white", borderRadius: 12, width: "100%", maxWidth: 400, maxHeight: "80vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: 16, borderBottom: "1px solid #E5E7EB" }}>
              <span style={{ fontSize: 18, fontWeight: "bold", color: "#111827" }}>Slip Gaji</span>
              <button onClick={() => setSelectedSlip(null)} style={{ background: "none", border: "none", cursor: "pointer", display: "flex" }}>
                <X size={24} color="#6B7280" />
              </button>
            </div>

            <div style={{ overflowY: "auto", padding: 16 }}>
              <p style={{ textAlign: "center", fontSize: 18, fontWeight: "bold", color: "#111827", margin: "0 0 20px" }}>{selectedSlip.bulan}</p>

              {/* Pendapatan */}
              <div style={{ marginBottom: 20, paddingBottom: 16, borderBottom: "1px solid #E5E7EB" }}>
                <p style={{ margin: "0 0 12px", fontSize: 12, fontWeight: 600, color: "#6B7280" }}>PENDAPATAN</p>
                {[
                  ["Gaji Pokok", selectedSlip.gajiPokok],
                  ["Tunjangan",  selectedSlip.tunjangan],
                  ...(selectedSlip.bonus > 0 ? [["Bonus", selectedSlip.bonus]] : []),
                ].map(([label, val]) => (
                  <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0" }}>
                    <span style={{ fontSize: 14, color: "#374151" }}>{label}</span>
                    <span style={{ fontSize: 14, fontWeight: 500, color: "#111827" }}>{formatCurrency(val)}</span>
                  </div>
                ))}
              </div>

              {/* Potongan */}
              <div style={{ marginBottom: 20, paddingBottom: 16, borderBottom: "1px solid #E5E7EB" }}>
                <p style={{ margin: "0 0 12px", fontSize: 12, fontWeight: 600, color: "#6B7280" }}>POTONGAN</p>
                <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0" }}>
                  <span style={{ fontSize: 14, color: "#374151" }}>BPJS & Pajak</span>
                  <span style={{ fontSize: 14, fontWeight: 500, color: "#EF4444" }}>{formatCurrency(selectedSlip.potongan)}</span>
                </div>
              </div>

              {/* Total */}
              <div style={{ backgroundColor: "#F3F4F6", padding: 16, borderRadius: 8, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 16, fontWeight: 600, color: "#111827" }}>Total Diterima</span>
                <span style={{ fontSize: 20, fontWeight: "bold", color: "#10B981" }}>{formatCurrency(selectedSlip.total)}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── ATTENDANCE TAB ───────────────────────────────────────────────────────────

function AttendanceTab() {
  const [expandedMonths, setExpandedMonths] = useState(["2024-12"]);
  const [selectedDay, setSelectedDay] = useState<any | null>(null);

  const toggleMonth = (key : string) =>
    setExpandedMonths(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);

  return (
    <div style={{ flex: 1, overflowY: "auto", padding: 16 }}>
      <p style={{ margin: "0 0 16px", fontSize: 18, fontWeight: "bold", color: "#111827" }}>Riwayat Absensi</p>

      {attendanceData.map(monthData => {
        const isExpanded = expandedMonths.includes(monthData.monthKey);
        return (
          <div key={monthData.monthKey} style={{ marginBottom: 16 }}>
            {/* Month Header */}
            <button onClick={() => toggleMonth(monthData.monthKey)}
              style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "space-between", backgroundColor: "white", padding: 16, borderRadius: 12, marginBottom: 8, boxShadow: "0 1px 3px rgba(0,0,0,0.06)", border: "none", cursor: "pointer", textAlign: "left" }}>
              <div>
                <p style={{ margin: "0 0 4px", fontSize: 16, fontWeight: 600, color: "#111827" }}>{monthData.bulan}</p>
                <p style={{ margin: 0, fontSize: 13, color: "#6B7280" }}>Kehadiran: {monthData.totalKehadiran}/{monthData.totalHari} sesi</p>
              </div>
              {isExpanded ? <ChevronUp size={24} color="#6B7280" /> : <ChevronDown size={24} color="#6B7280" />}
            </button>

            {/* Day Cards */}
            {isExpanded && monthData.data.map((item, i) => (
              <button key={i} onClick={() => setSelectedDay({ ...item, bulan: monthData.bulan })}
                style={{ display: "flex", width: "100%", alignItems: "stretch", gap: 12, backgroundColor: "white", padding: 12, borderRadius: 12, marginBottom: 8, boxShadow: "0 1px 3px rgba(0,0,0,0.06)", border: "none", cursor: "pointer", textAlign: "left" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 50, minWidth: 50, backgroundColor: "#F3F4F6", borderRadius: 8, padding: 6 }}>
                  <span style={{ fontSize: 20, fontWeight: "bold", color: "#111827" }}>{item.tanggal}</span>
                  <span style={{ fontSize: 10, color: "#6B7280" }}>{monthData.bulan.split(" ")[0].substring(0, 3)}</span>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                    <span style={{ fontSize: 14, fontWeight: 600, color: "#111827" }}>{item.hari}</span>
                    <span style={{ fontSize: 11, fontWeight: 600, color: "white", backgroundColor: getStatusColor(item.status), padding: "2px 8px", borderRadius: 8 }}>
                      {item.status}
                    </span>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    {([ ["Pagi - Siang:", item.sesi1], ["Siang - Sore:", item.sesi2] ] as Array<[string, { hadir: boolean; jamMasuk: string; jamKeluar: string; }]>).map(([label, sesi]) => (
                      <div key={label} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 12, color: "#6B7280", width: 90, flexShrink: 0 }}>{label}</span>
                        {sesi.hadir ? (
                          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                            <Check size={14} color="#10B981" />
                            <span style={{ fontSize: 12, color: "#10B981", fontWeight: 500 }}>Ada</span>
                          </div>
                        ) : (
                          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                            <XCircle size={14} color="#EF4444" />
                            <span style={{ fontSize: 12, color: "#EF4444", fontWeight: 500 }}>Tidak</span>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </button>
            ))}
          </div>
        );
      })}

      {/* Modal Detail Absensi */}
      {selectedDay && (
        <div onClick={() => setSelectedDay(null)}
          style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "flex-end", zIndex: 1000 }}>
          <div onClick={e => e.stopPropagation()}
            style={{ backgroundColor: "white", borderTopLeftRadius: 20, borderTopRightRadius: 20, width: "100%", maxHeight: "85vh", display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: 16, borderBottom: "1px solid #E5E7EB" }}>
              <span style={{ fontSize: 18, fontWeight: "bold", color: "#111827" }}>Detail Absensi</span>
              <button onClick={() => setSelectedDay(null)} style={{ background: "none", border: "none", cursor: "pointer", display: "flex" }}>
                <X size={24} color="#6B7280" />
              </button>
            </div>

            <div style={{ overflowY: "auto", padding: 16 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, paddingBottom: 16, borderBottom: "1px solid #E5E7EB" }}>
                <span style={{ fontSize: 16, fontWeight: 600, color: "#111827", flex: 1 }}>
                  {selectedDay.hari}, {selectedDay.tanggal} {selectedDay.bulan}
                </span>
                <span style={{ fontSize: 12, fontWeight: 600, color: "white", backgroundColor: getStatusColor(selectedDay.status), padding: "4px 12px", borderRadius: 12 }}>
                  {selectedDay.status}
                </span>
              </div>

              {[
                { title: "Sesi 1: Pagi - Siang", sesi: selectedDay.sesi1 },
                { title: "Sesi 2: Siang - Sore",  sesi: selectedDay.sesi2 },
              ].map(({ title, sesi }) => (
                <div key={title} style={{ backgroundColor: "#F9FAFB", padding: 12, borderRadius: 8, marginBottom: 12 }}>
                  <p style={{ margin: "0 0 12px", fontSize: 14, fontWeight: 600, color: "#111827" }}>{title}</p>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0" }}>
                    <span style={{ fontSize: 13, color: "#6B7280" }}>Status:</span>
                    {sesi.hadir ? (
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        <Check size={16} color="#10B981" />
                        <span style={{ fontSize: 13, color: "#10B981", fontWeight: 600 }}>Hadir</span>
                      </div>
                    ) : (
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        <XCircle size={16} color="#EF4444" />
                        <span style={{ fontSize: 13, color: "#EF4444", fontWeight: 600 }}>Tidak Hadir</span>
                      </div>
                    )}
                  </div>
                  {sesi.hadir && (
                    <>
                      {[["Jam Masuk:", sesi.jamMasuk], ["Jam Keluar:", sesi.jamKeluar]].map(([label, val]) => (
                        <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0" }}>
                          <span style={{ fontSize: 13, color: "#6B7280" }}>{label}</span>
                          <span style={{ fontSize: 13, fontWeight: 500, color: "#111827" }}>{val}</span>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              ))}

              <div style={{ backgroundColor: "#EFF6FF", padding: 12, borderRadius: 8, borderLeft: "3px solid #3B82F6" }}>
                <p style={{ margin: "0 0 8px", fontSize: 13, fontWeight: 600, color: "#1E40AF" }}>ℹ️ Keterangan:</p>
                {[
                  "• Absensi dihitung berdasarkan 2 sesi dalam sehari",
                  "• Sesi 1: Pagi hingga Siang (08:00 - 12:00)",
                  "• Sesi 2: Siang hingga Sore (13:00 - 17:00)",
                  "• Kehadiran penuh = kedua sesi hadir",
                ].map((note, i) => (
                  <p key={i} style={{ margin: "0 0 4px", fontSize: 12, color: "#1E40AF", lineHeight: 1.5 }}>{note}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── MAIN APP ─────────────────────────────────────────────────────────────────

export default function HomeMobilePersonalia() {
  const [activeTab, setActiveTab] = useState("profile");
  const [personalData, setPersonalData] = useState<any>(null);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh", backgroundColor: "#F3F4F6", maxWidth: 480, margin: "0 auto", fontFamily: "system-ui, -apple-system, sans-serif" }}>
      <div style={{ backgroundColor: "#3B82F6", padding: 16 }}>
        <h1 style={{ margin: 0, fontSize: 20, fontWeight: "bold", color: "white" }}>Personalia</h1>
      </div>
      <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
        {activeTab === "profile"    && <ProfileTab />}
        {activeTab === "salary"     && <SalaryTab />}
        {activeTab === "attendance" && <AttendanceTab />}
      </div>
      <TabBar activeTab={activeTab} setActiveTab={setActiveTab} />
    </div>
  );
}